import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-attendance-check-in-out-legend',
  templateUrl: './attendance-check-in-out-legend.component.html'
})
export class AttendanceCheckInOutLegendComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<AttendanceCheckInOutLegendComponent>
  ) { }

  ngOnInit() {
  }

  closeClick() {
    this.dialogRef.close();
  }

}
